module.exports = __webpack_public_path__ + "img/006王春明.617bc9b1.png";